<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>SMS Broadcast - New Message</h1>
        <v-divider class="py-3"></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-tabs>
          <v-tab exact :to="{ name: 'SMSBroadcastRoute' }">New Message</v-tab>
          <v-tab exact :to="{ name: 'SMSBroadcastLogRoute' }">Message Log</v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-sheet elevation="1" class="pa-4" rounded>
          <v-col cols="12">
            <v-row>
              <v-col cols="12">
                <v-alert
                  type="success"
                  v-if="success"
                  dismissible
                  @input="success = false">
                  Messages sent successfully!
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-form>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-model="selectedGroup"
                        :items="groups"
                        label="Target Group"
                        hide-details
                        outlined>
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3" v-for="location in locations" :key="location.id">
                      <v-checkbox
                        v-model="selectedLocations"
                        :disabled="locationsLoading"
                        :label="location.attributes.name"
                        :value="location.attributes.name"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        label="Message"
                        rows="5"
                        outlined
                        ref="message"
                        v-model="message"
                        counter="160">
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-right">
                      <v-btn
                        color="primary"
                        x-large
                        depressed
                        :loading="sendPending"
                        @click="sendMessage"
                        :disabled="!message || !selectedGroup || messageLength > 160 || sendPending">
                        Send Message
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-col>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex/dist/vuex.common.js';

export default {
  name: 'SMSBroadcastPage',

  data () {
    return {
      message: '',
      selectedGroup: null,
      groups: [
        { text: 'Instructors', value: 'Instructor' },
        { text: 'Front Desk', value: 'Front Desk' },
        { text: 'Studio Managers', value: 'Studio Manager' },
        { text: 'All Employees', value: 'all_employees' },
      ],
      selectedLocations: [],
      sendPending: false,
      success: false,
    }
  },

  computed: {
    messageLength() {
      return this.message.length
    },
    ...mapGetters({
      locations: 'location/list'
    }),
    locationsLoading() {
      return this.$store.state['location'].isFindPending
    },
  },

  methods: {
    async sendMessage() {
      this.sendPending = true
      this.$store.dispatch('sms-broadcast/create', {
        message: this.message,
        group: this.selectedGroup,
        locations: this.selectedLocations,
      })
        .then(() => {
          this.message = ''; // Clear the message after sending
          this.selectedGroup = null; // Reset the selected group
          this.selectedLocation = null; // Reset the selected location
          this.sendPending = false
          this.success = true
        })
        .catch(error => {
          console.error('Error sending SMS:', error)
          this.sendPending = true
        })
    },
  },

  async beforeMount() {
    await this.$store.dispatch('location/find')
  }
}
</script>

<style lang="scss">

</style>